import { GridColumnProps } from '@roc/ui';
import { noOpComparator } from '@roc/ui/utils';

export const DEFAULT_SORT_MODEL = [{ colId: 'delay', sort: 'desc' }];

export const internalValuationCriticalColumns: GridColumnProps[] = [
  {
    field: 'priority',
    headerName: 'Priority',
    maxWidth: 140,
    comparator: noOpComparator,
    cellRenderer: 'priorityCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 110,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    cellRenderer: 'internalValuationStatusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'In Underwriting', value: 'IN_UNDERWRITING' },
        { label: 'Agreed', value: 'AGREED' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
        { label: 'Pending Term Sheet', value: 'PENDING_TERM_SHEET' },
        { label: 'Prescreen', value: 'PRESCREEN' },
        { label: 'Term Sheet Out', value: 'TERM_SHEET_OUT' },
        { label: 'Unknown', value: 'UNKNOWN' },
        { label: 'Pre-Submission', value: 'PENDING_SUBMISSION' },
        { label: 'Deal Room', value: 'DEAL_ROOM' },
      ],
    },
  },
  {
    field: 'subStatus',
    headerName: 'Sub Status',
    minWidth: 240,
    cellRenderer: 'internalValuationSubStatusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Data Entry No Appraisal', value: 'DATA_ENTRY_NO_APPRAISAL' },
        { label: 'Data Entry Appraisal', value: 'DATA_ENTRY_APPRAISAL' },
        { label: 'Structuring', value: 'STRUCTURING' },
        { label: 'In Underwriting', value: 'UNDERWRITING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
      ],
    },
  },
  {
    field: 'valuationReviewer',
    headerName: 'Valuation Reviewer',
    minWidth: 220,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'address',
    headerName: 'Address',
    minWidth: 280,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'state',
    headerName: 'State',
    minWidth: 110,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyType',
    headerName: 'Property Type',
    minWidth: 135,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 160,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'reason',
    headerName: 'Reason',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];
